import { render, staticRenderFns } from "./DetailLaporanInisiasi.vue?vue&type=template&id=1a31fd6f"
import script from "./DetailLaporanInisiasi.vue?vue&type=script&lang=js"
export * from "./DetailLaporanInisiasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports